import { eActionType } from './action-types';
import {
    ActionVersion0,
    ActionVersionBase,
} from './action-version-implementation';
// import {eActionType} from '@common/actions/action-types';
import { TranslateService } from '@ngx-translate/core';

export enum EActionsVersions {
    VERSION_BASE = -1,
    VERSION_0 = 0,
}

const actionsList = {
    [EActionsVersions.VERSION_BASE]: ActionVersionBase,
    [EActionsVersions.VERSION_0]: ActionVersion0,
};

export type TActionImplementation = ActionVersionBase | ActionVersion0;
type TActionArguments = [eActionType, TranslateService];

export class ActionVersionFactory {
    public static getActionByVersion(
        version: EActionsVersions,
        ...args: TActionArguments
    ): TActionImplementation {
        return new actionsList[version](version, ...args);
    }
}
